
import * as THREE from 'three';

export type FurnitureType = {
    category: string,
    width: number;
    height: number;
    depth: number;
    rotation: number;
    position: THREE.Vector3
}

export class FurnitureInfo {

    public furnitureObjects: FurnitureType[][] = [[], [], []];

    constructor(private objects: any) {
        ;
    }

    /**
     * 家具・住設データ構築
     * */
    public execute(): FurnitureType[][] {
        this.objects.forEach((floorObjects, floor: number) => {
            floorObjects.forEach((obj) => {
                const category = obj.category;
                const width = obj.dimensions[0] * 1000;
                const height = obj.dimensions[1] * 1000;
                const depth = obj.dimensions[2] * 1000;
                const transform = obj.transform;
                const matrix = new THREE.Matrix4();
                matrix.elements = transform;
                const position = new THREE.Vector3();
                const quaternion = new THREE.Quaternion();
                matrix.decompose(position, quaternion, new THREE.Vector3());
                const vec3 = new THREE.Vector3(1, 0, 0).applyQuaternion(quaternion);
                const rotation = vec3.angleTo(new THREE.Vector3(1, 0, 0));
                const sin = vec3.clone().normalize().clone().cross(new THREE.Vector3(1, 0, 0));
                const deg = sin.y > 0 ? THREE.MathUtils.radToDeg(rotation) : - THREE.MathUtils.radToDeg(rotation);
                
                this.furnitureObjects[floor].push({
                    category: category,
                    width: width,
                    height: height,
                    depth: depth,
                    position: position,
                    rotation: deg
                });
            });
        });

        return this.furnitureObjects;
    }
    
    /**
     * 45度単位にする
     * */
    static unit45deg(deg: number) {
        if (-360 <= deg && deg <= -337.5) return -360;
        if (-337.5 <= deg && deg <= -292.5) return -315;
        if (-292.5 <= deg && deg <= -247.5) return -270;
        if (-247.5 <= deg && deg <= -202.5) return -225;
        if (-202.5 <= deg && deg < -157.5) return -180;
        if (-157.5 <= deg && deg < -112.5) return -135;
        if (-112.5 <= deg && deg < -67.5) return -90;
        if (-67.5 <= deg && deg < -22.5) return -45;
        if (-22.5 <= deg && deg < 22.5) return 0;
        if (22.5 <= deg && deg < 67.5) return 45;
        if (67.5 <= deg && deg < 112.5) return 90;
        if (112.5 <= deg && deg < 157.5) return 135;
        if (157.5 <= deg && deg <= 202.5) return 180;
        if (202.5 <= deg && deg <= 247.5) return 225;
        if (247.5 <= deg && deg <= 292.5) return 270;
        if (292.5 <= deg && deg <= 337.5) return 315;
        if (337.5 <= deg && deg <= 360) return 360;
        return deg;
    }
}